import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TitleManager = () => {
  const location = useLocation();

  useEffect(() => {
    const titles = {
      "/": "#1 Web & Mobile App Development Company in Salem",
      "/aboutus/": "About Us",
      "/contact": "Contact Us",
      "/privacypolicy/": "Privacy Policy",
      "/termsandconditions/": "Terms & Conditions",
      "/uiuxdesign": "UIUXdesign",
      "/mobile-application-development": "Application Developement",
      "/web-development": "Website Developement",
      "/digital-marketing": "DigitalMarketing",
      "/customsoftwaresolution": "Custom Software Solution",
      "/seoservices": "SEO Services",
      "/social-media-marketing": "Social Media Marketing",
      "/ecommerce": "E-commerce",
      "/wordpress": "Word Press",
      "/php-dev": "PHP Developer",
      "/laravel-dev": "Laravel Developer",
      "/react-dev": "React Developer",
      "/node-dev": "Node Developer",
      "/flutter-dev": "Flutter Developer",
      "/python-dev": "Python Developer",
      "/qa-engineers": "QA Engineer",
      "/portfolio": "Portfolio",
      "/e-commerce": "E-commerce"
    };

    document.title = titles[location.pathname] || "MPeoples"; 
  }, [location.pathname]);

  return null; 
};

export default TitleManager;
